import React from "react";
import "./footer.css";

const Footer = () => {
  return (
    <div className="footer-wrapper">
      <div className="max-width flex footer simple-footer">

        {/* Left Side: Logo + Name */}
        <div className="footer-left flex flex-center">
          
          <span className="footer-name">Crosswalk</span>
        </div>

        {/* Right Side: Copyright */}
        <div className="footer-right">
          © {new Date().getFullYear()} Crosswalk. all rights reserved.
        </div>

      </div>
    </div>
  );
};

export default Footer;
